import { render, staticRenderFns } from "./DefaultColumnItem.vue?vue&type=template&id=66215738&"
import script from "./DefaultColumnItem.vue?vue&type=script&lang=ts&"
export * from "./DefaultColumnItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports